import React from 'react';
import './footer.css'; // Import Footer specific CSS
import logo from './../../assets/images/logo.png';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Logo Section */}
                <div className="footer-logo-section">
                    <img src={logo} alt="Hcura Logo" className="footer-logo" />
                    <p className="footer-description">
                        Hcura Homeopathy Multi-Speciality Hospital, led by expert homeopaths, delivers quality healthcare combining expertise and compassion for all sections of society.
                    </p>
                </div>

                {/* Links Section */}
                <div className="footer-links">
                    <div className="footer-column">
                        <h4>Enquiry Us</h4>
                        <p><a href="tel:8870001377">+91 8870001377</a></p>
                        <p><a href="tel:7411845662">+91 7411845662</a></p>
                        <h4>Email Us</h4>
                         <p>
                            <a href="care@h-cura.com">care@h-cura.com</a>
                        </p>
                        <p><a href="admin@h-cura.com">admin@h-cura.com</a></p>
                    </div>
                    <div className="footer-column">
                        <h4>Registered Office</h4>
                        <p>h-cura Homeopathy Multispecialty Clinic
                                No:779&780 2nd Floor, Sai Towers Building,
                                South, E End Main Rd, Bengaluru,
                                Karnataka 560069, India
                               </p>
                    </div>

                    <div className="footer-column">
                        <h4>Useful Links</h4>
                        <p onClick={() => handleNavigation('/')}>Home</p>
                        <p onClick={() => handleNavigation('/about/')}>About Us</p>
                        <p onClick={() => handleNavigation('/contact-us/')}>Contact Us</p>
                    </div>
                    <div className="footer-column">
                            <h4>Our Clinics</h4>
                            
                            <h5>Bangalore</h5>
                            <ul>
                                <p onClick={() => handleNavigation('/homeopathy-clinic-in-bangalore/')}>1. Jayanagar</p>
                            </ul>
                            
                            <h5>Chennai</h5>
                            <ul>
                                <p onClick={() => handleNavigation('/homeopathy-clinic-in-valasaravakkam-chennai')}> 1. Valasaravakkam</p>
                                <p onClick={() => handleNavigation('/homeopathy-clinic-in-madanandapuram-chennai/')}> 2. Madhanathapuram</p>
                            </ul>
                        </div>


                    <div className="footer-column">
                        <h4>Treatments</h4>
                        <p>Skin Diseases</p>
                        <p>Hairfall</p>
                        <p>Diabetes</p>
                        <p>Piles</p>
                        <p>Male Infertility</p>
                    </div>

                    <div className="footer-column">
                        <h4>Policies</h4>
                        <p onClick={() => handleNavigation('/privacypolicy')}>Privacy Policy</p>
                        <p onClick={() => handleNavigation('/terms')}>Terms and conditions</p>
                        <p onClick={() => handleNavigation('/disclaimer')}>Disclamair</p>
                        <p onClick={() => handleNavigation('/')}>Refund & Cancellation Policy</p>
                       
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
